export const tabwatchertimer = {
    namespaced: true,
    state: {
        watcher: null,
    },
    actions: {
        add({ commit}, watcher) {
            commit('add', watcher);
        },
        clear({ commit, state }) {
            clearInterval(state.watcher);
            commit('clear');
        }
    },
    mutations: {
        add(state, watcher) {
            state.watcher = watcher;
        },
        clear(state) {
            state.watcher = null;
        }
    }
}
